module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Checkbox"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Checkbox")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Checkbox can be used alone to switch between two states. Disabled state for checkbox")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Option")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.checked1),
      callback: function($$v) {
        _vm.checked1 = $$v
      },
      expression: "checked1"
    }
  }, [_vm._v("Option")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.checked2),
      callback: function($$v) {
        _vm.checked2 = $$v
      },
      expression: "checked2"
    }
  }, [_vm._v("Option")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Checkbox group")]), _vm._v(" "), _c('p', [_vm._v("It is used for multiple checkboxes which are bound in one group, and indicates whether one option is selected by checking if it is checked.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Option A"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Option B"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Option C"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "disabled",
      "disabled": ""
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "selected and disabled",
      "disabled": ""
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27b333da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormCheckbox.vue
// module id = 1276
// module chunks = 2